"use client";

import { type PropsWithChildren, useEffect } from "react";
import { I18nProvider, useLocale } from "react-aria";

export function Locale(props: PropsWithChildren<{ locale?: string }>) {
	const { locale } = useLocale();
	useEffect(() => {
		// biome-ignore lint/suspicious/noDocumentCookie: need to do it
		document.cookie = `locale=${locale}; path=/`;
	}, [locale]);
	return (
		<I18nProvider locale={props.locale ?? locale}>
			{props.children}
		</I18nProvider>
	);
}
